// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".appointment-card[data-v-6869a476]{border:1px solid #1cacda;height:100%;cursor:pointer;position:relative}.overlay[data-v-6869a476]{width:100%;height:100%;position:absolute;top:0;left:0;background:hsla(0,0%,100%,.3764705882352941)}", ""]);
// Exports
module.exports = exports;
